// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  GKPRODUCT_CHOOSE_CURRENT_PRODUCT,
} from './constants';

export function chooseCurrentProduct(model) {
  return {
    type: GKPRODUCT_CHOOSE_CURRENT_PRODUCT,
    data:model
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case GKPRODUCT_CHOOSE_CURRENT_PRODUCT:
      return {
        ...state,
        currentProduct:action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/gkproduct/redux/chooseCurrentProduct.js